export default __webpack_public_path__ + "static/media/6.0a7c2bd4.png";